module.exports = __webpack_public_path__ + "img/yk_regist_query.41e95949.png";